/* Floretti 3.0 — telanimatie voor de impact strip.
   Custom element, zodat de sectie zichzelf opnieuw initialiseert in de
   theme-editor. Respecteert prefers-reduced-motion. */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)');

  function formatNumber(value) {
    return new Intl.NumberFormat(document.documentElement.lang || 'nl-NL').format(value);
  }

  function animate(el) {
    var target = parseInt(el.getAttribute('data-count-to'), 10);
    if (isNaN(target)) return;
    var suffix = el.getAttribute('data-count-suffix') || '';

    if (REDUCED.matches || target === 0) {
      el.textContent = formatNumber(target) + suffix;
      return;
    }

    var duration = 1400;
    var start = null;

    function step(timestamp) {
      if (start === null) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      // easeOutCubic
      var eased = 1 - Math.pow(1 - progress, 3);
      el.textContent = formatNumber(Math.round(target * eased)) + suffix;
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  class FlorettiCountUp extends HTMLElement {
    connectedCallback() {
      var targets = this.querySelectorAll('[data-count-to]');
      if (!targets.length) return;

      if (!('IntersectionObserver' in window)) {
        targets.forEach(animate);
        return;
      }

      var observer = new IntersectionObserver(
        function (entries, obs) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            animate(entry.target);
            obs.unobserve(entry.target);
          });
        },
        { threshold: 0.4 }
      );

      targets.forEach(function (el) {
        observer.observe(el);
      });
      this._observer = observer;
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
    }
  }

  if (!customElements.get('floretti-count-up')) {
    customElements.define('floretti-count-up', FlorettiCountUp);
  }
})();
